import type { PriceListMtrRowData } from 'gql/graphql';

import type { TextFieldPropValue } from '@consta/uikit/TextField';
import { TextField } from '@consta/uikit/TextField';

interface ITextFieldAddMtr {
    valueNote: Record<number, string>;
    handleChangesValueNote: (rowId: number) => ({ value }: { value: TextFieldPropValue }) => void;
    data: PriceListMtrRowData;
    checkedIds: Record<string, boolean>;
}

export const CellRenderTextField = (props: ITextFieldAddMtr) => {
    const { valueNote, handleChangesValueNote, data, checkedIds } = props;

    return (
        <div>
            <TextField
                value={valueNote[data?.id]}
                onChange={handleChangesValueNote(data?.id)}
                disabled={!checkedIds[data?.id]}
                placeholder="Введите примечание"
                size="s"
            />
        </div>
    );
};

CellRenderTextField.displayName = 'CellRenderTextField';
